import { PureComputed } from "knockout"
import { WCCSliderAlignment } from "./enums/alignment"
import { WCCSliderLayoutConfig } from "./factories/layout.interfaces"
import { WCCSliderAutoScrollManagerConfigPublic } from "./managers/autoScroll"
import { WCCSliderConfig, WCCSliderOtherPagesConfig, WCCSliderOtherPagesNormalizedConfig } from "./slider.interfaces"
import { WCCSliderAnimatorType } from "./types/animatorType"

export class WCCSlider<T> {
    source: PureComputed<T[]>
    layout: PureComputed<WCCSliderLayoutConfig>
    animation: PureComputed<WCCSliderAnimatorType>
    alignment: PureComputed<WCCSliderAlignment>

    otherPages: PureComputed<WCCSliderOtherPagesNormalizedConfig>
    autoScroll: PureComputed<WCCSliderAutoScrollManagerConfigPublic | undefined>

    selectedItem: PureComputed<T | undefined>

    showControls: PureComputed<boolean>
    showControlsOverContent: PureComputed<boolean>
    showPages: PureComputed<boolean>
    centerFirstPage: PureComputed<boolean>

    constructor(jsonSlider: WCCSliderConfig<T>) {
        this.source = ko.observable(jsonSlider.Source ?? jsonSlider.source).unwrap().default([]).extend({ deferred: true });
        this.layout = ko.observable(jsonSlider.Layout ?? jsonSlider.layout).unwrap().default({ type: 'adaptive' });
        this.animation = ko.observable(jsonSlider.Animation ?? jsonSlider.animation).unwrap().default('slide');
        this.selectedItem = <PureComputed<T | undefined>>ko.observable(jsonSlider.SelectedItem ?? jsonSlider.selectedItem).unwrap();
        this.alignment = ko.observable(jsonSlider.Alignment ?? jsonSlider.alignment).unwrap().default(WCCSliderAlignment.left);
        this.showControls = ko.observable(jsonSlider.ShowControls ?? jsonSlider.showControls).unwrap().default(true);
        this.showControlsOverContent = ko.observable(jsonSlider.ShowControlsOverContent ?? jsonSlider.showControlsOverContent).unwrap().default(true);
        this.showPages = ko.observable(jsonSlider.ShowPages ?? jsonSlider.showPages).unwrap().default(false);
        this.centerFirstPage = ko.observable(jsonSlider.centerFirstPage).unwrap().default(false);
        this.otherPages = ko.observable(jsonSlider.OtherPages ?? jsonSlider.otherPages).unwrap().mapSingle(config => this.getOtherPagesConfig(config));
        this.autoScroll = ko.observable(jsonSlider.AutoScroll ?? jsonSlider.autoScroll).unwrap();
    }

    private getOtherPagesConfig(config?: boolean | WCCSliderOtherPagesConfig): WCCSliderOtherPagesNormalizedConfig {
        if (_.isObject(config))
            return { show: ko.flattenComputed(config.show, true), itemWidth: ko.flattenComputed(config.itemWidth, 1) }
        else
            return { show: ko.flattenComputed(config, false), itemWidth: ko.flattenComputed(1) }
    }    
}